/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExecutionsAvailable } from './ExecutionsAvailable';
import {
    ExecutionsAvailableFromJSON,
    ExecutionsAvailableFromJSONTyped,
    ExecutionsAvailableToJSON,
    ExecutionsAvailableToJSONTyped,
} from './ExecutionsAvailable';

/**
 * 
 * @export
 * @interface FindOneExecutionsAvailableByFacilityId200Response
 */
export interface FindOneExecutionsAvailableByFacilityId200Response {
    /**
     * 
     */
    data?: ExecutionsAvailable;
}

/**
 * Check if a given object implements the FindOneExecutionsAvailableByFacilityId200Response interface.
 */
export function instanceOfFindOneExecutionsAvailableByFacilityId200Response(value: object): value is FindOneExecutionsAvailableByFacilityId200Response {
    return true;
}

export function FindOneExecutionsAvailableByFacilityId200ResponseFromJSON(json: any): FindOneExecutionsAvailableByFacilityId200Response {
    return FindOneExecutionsAvailableByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindOneExecutionsAvailableByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneExecutionsAvailableByFacilityId200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ExecutionsAvailableFromJSON(json['data']),
    };
}

export function FindOneExecutionsAvailableByFacilityId200ResponseToJSON(json: any): FindOneExecutionsAvailableByFacilityId200Response {
    return FindOneExecutionsAvailableByFacilityId200ResponseToJSONTyped(json, false);
}

export function FindOneExecutionsAvailableByFacilityId200ResponseToJSONTyped(value?: FindOneExecutionsAvailableByFacilityId200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ExecutionsAvailableToJSON(value['data']),
    };
}

